<script lang="ts">
  export let containerType: string;
  export let inventoryId: number;
  export let label: string;
</script>

<span data-testid={`cart-widget-label-${containerType}-${inventoryId}`}>{label}</span>
